import { render } from "./FloatButton.vue?vue&type=template&id=b54f454a"
import script from "./FloatButton.vue?vue&type=script&lang=js"
export * from "./FloatButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__